import { Card, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { type CtsModuleSpecsFragment } from '../../../../api/fragments/CtsModuleSpecs';

type CtsModuleTabAuthorizationProps = {
    module: CtsModuleSpecsFragment;
};

const CtsModuleTabAuthorization = ({ module }: CtsModuleTabAuthorizationProps) => {
    const { t } = useTranslation(['ctsModuleDetails']);

    return (
        <Card>
            <Descriptions column={{ xs: 1, md: 2 }} bordered>
                <Descriptions.Item label={t('ctsModuleDetails:tabs.authorization.descriptions.accessKey')}>
                    {module.authorization.accessKey}
                </Descriptions.Item>
                <Descriptions.Item label={t('ctsModuleDetails:tabs.authorization.descriptions.secretKey')}>
                    {module.authorization.secretKey}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default CtsModuleTabAuthorization;
